import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import Hero from '@/pages/traffic-pro/components/Hero';
import Includes from '@/pages/traffic-pro/components/Includes';
import Process from '@/pages/traffic-pro/components/Process';
import Pricing from '@/pages/traffic-pro/components/Pricing';
import HowWeWork from '@/pages/traffic-pro/components/HowWeWork';
import WhyChooseUs from '@/pages/traffic-pro/components/WhyChooseUs';
import ExpectedResults from '@/pages/traffic-pro/components/ExpectedResults';
import FAQ from '@/pages/traffic-pro/components/FAQ';
import FinalCTA from '@/pages/traffic-pro/components/FinalCTA';

export default function TrafficPro() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Includes />
        <Process />
        <Pricing />
        <HowWeWork />
        <WhyChooseUs />
        <ExpectedResults />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}